module.exports = __webpack_public_path__ + "media/images/icon__dhi--rb-gray@3x-25a33ca6e196d1e2940b11b7740ffab7.png";